import React, { useEffect, useMemo, useState } from "react";
import Async from "react-select/async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { AsyncSearchResult, customStyles } from "./types";
import { DropdownOption } from "./DropdownOption";
import { MenuListProps, MenuProps, OptionProps } from "react-select";
import "./GeoEncoder.scss";

export type AsyncSelectComponentType = {
    Option?: React.FC<OptionProps>;
    Menu?: React.FC<MenuProps>;
    MenuList?: React.FC<MenuListProps>;
};
// Partial<SelectComponents<unknown, boolean, GroupBase<unknown>>>;

interface AsyncSelectProps {
    components?: AsyncSelectComponentType;
    onChange?: (item: AsyncSearchResult) => void;
    value?: AsyncSearchResult;
    getValues?: (text: string) => Promise<Array<AsyncSearchResult>>;
    placeholder: string;
}

const defaultComponents: AsyncSelectComponentType = { Option: DropdownOption };
export const AsyncSelect: React.FC<AsyncSelectProps> = ({
    onChange,
    value,
    getValues,
    placeholder,
    components = defaultComponents
}) => {
    const [_value, _setValue] = useState<AsyncSearchResult>(value);

    useEffect(() => {
        _setValue(value);
    }, [value]);

    const _onChange = useMemo(() => {
        return (item: AsyncSearchResult) => {
            _setValue(item);
        };
    }, []);

    return (
        <div className="geo-encoder">
            <Async
                isClearable
                cacheOptions
                components={components}
                // components={{ Option: Blah }}
                loadOptions={getValues}
                value={
                    _value && {
                        label: _value,
                        value: _value
                    }
                }
                onChange={onChange ?? _onChange}
                isLoading={false}
                defaultOptions={[]}
                placeholder={placeholder}
                styles={customStyles}
                theme={theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: "#28336E"
                    }
                })}
            />

            <div className={"search-indicator"}>
                <FontAwesomeIcon icon={faSearch} />
            </div>
        </div>
    );
};
